export default {
    'diagram4-3a1': {
        'diagram-number': '4.',
        'elements': {
            'one': 'The western window is the only window that looks directly out on the moor',
            'two': 'Barrymore was staring out of the western window',
            'three': 'Therefore Barrymore must have been looking for something or someone on the moor',
        }
    }
}


// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a1/diagram4/i18n/en.js